// src/components/CompetitionRev.js
import React, { useEffect, useState } from "react";
import { collection, getDocs } from "firebase/firestore";
import { db } from "./firebase"; // adjust path if needed

const CompetitionRev = () => {
  const [musicians, setMusicians] = useState([]);
  const [loading, setLoading] = useState(true);
  const [copied, setCopied] = useState(false);

  useEffect(() => {
    const fetchMusicians = async () => {
      try {
        const querySnapshot = await getDocs(collection(db, "External Musicians"));
        const data = querySnapshot.docs.map((doc) => ({
          id: doc.id,
          ...doc.data(),
        }));
        setMusicians(data);
      } catch (error) {
        console.error("Error fetching musicians:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchMusicians();
  }, []);

  const copyEmails = () => {
    const allEmails = musicians.map((m) => m.email).join(", ");
    navigator.clipboard.writeText(allEmails);
    setCopied(true);
    setTimeout(() => setCopied(false), 2000);
  };

  if (loading) return <p className="text-gray-600">Loading musicians...</p>;

  return (
    <div style={{ padding: "20px", fontFamily: "Arial, sans-serif" }}>
      <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
        <h2>🎶 External Musicians</h2>
        <button
          onClick={copyEmails}
          style={{
            padding: "8px 14px",
            backgroundColor: "#2563eb",
            color: "white",
            border: "none",
            borderRadius: "6px",
            cursor: "pointer",
          }}
        >
          {copied ? "✅ Emails Copied!" : "Copy All Emails"}
        </button>
      </div>

      <table
        style={{
          width: "100%",
          marginTop: "20px",
          borderCollapse: "collapse",
          backgroundColor: "white",
          boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
        }}
      >
        <thead style={{ backgroundColor: "#f3f4f6" }}>
          <tr>
            <th style={thStyle}>Name</th>
            <th style={thStyle}>Instrument</th>
            <th style={thStyle}>Age</th>
            <th style={thStyle}>Email</th>
            <th style={thStyle}>Phone</th>
          </tr>
        </thead>
        <tbody>
          {musicians.map((m) => (
            <tr key={m.id} style={{ borderBottom: "1px solid #e5e7eb" }}>
              <td style={tdStyle}>{m.firstName} {m.lastName}</td>
              <td style={tdStyle}>{m.instrument}</td>
              <td style={tdStyle}>{m.age}</td>
              <td style={tdStyle}><a href={`mailto:${m.email}`} style={{ color: "#2563eb" }}>{m.email}</a></td>
              <td style={tdStyle}>{m.phone}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

// Reusable styles
const thStyle = {
  textAlign: "left",
  padding: "10px",
  fontWeight: "600",
  borderBottom: "2px solid #d1d5db",
};

const tdStyle = {
  padding: "10px",
  fontSize: "14px",
};

export default CompetitionRev;
